import { useQuery } from "@tanstack/react-query"
import { getServerHealthApi } from "../api.service";

export interface GetHealthResponse {
    data: HealthResponseData;
    statusCode: number;
    message: string;
    metadata: string;
}

export interface HealthResponseData {
    serverDetails: ServerDetails;
    djangoDetails: DjangoDetails;
    frontendVersion: string | null;
    serviceStatus: ServiceStatus;
    processInfo: ProcessInfo;
    systemLoad: SystemLoad;
    memoryDetails: MemoryDetails;
    diskDetails: DiskDetails;
}

export interface DjangoDetails {
    djangoVersion: string;
    djangoDebug: boolean;
    databaseName: string;
    installedApps: number;
    middlewareCount: number;
    staticUrl: string;
    mediaUrl: string;
}

export interface ServerDetails {
    baseUrl: string;
    serverTime: string;
    serverName: string;
    serverIP: string;
    publicIP: string;
    os: string;
    osVersion: string;
    pythonVersion: string;
    cpuUsage: string;
    memoryUsage: string;
    diskUsage: string;
    uptime: string;
    djangoDebug: boolean;
    url: string;
    status: string;
}

export interface ServiceStatus {
    database: {
        status: string;
        responseTime: string;
    };
    network: {
        status: string;
        responseTime: string;
    };
    frontend: {
        status: string;
        version: string | null;
    };
}

export interface ProcessInfo {
    pid: number;
    memoryUsageMB: number;
    cpuPercent: number;
    numThreads: number;
    createTime: string;
}

export interface SystemLoad {
    load1min: number | string;
    load5min: number | string;
    load15min: number | string;
}

export interface MemoryDetails {
    totalGB: number;
    availableGB: number;
    usedGB: number;
    freeGB: number;
}

export interface DiskDetails {
    totalGB: number;
    usedGB: number;
    freeGB: number;
}

export const useGetHealthStatus = () => {
    return useQuery({
        queryKey: ['healthStatus'],
        queryFn: async () => {
            const response = await getServerHealthApi();
            return response as GetHealthResponse
        },
        staleTime: 3600000, // 1 hour
        retry: 1,
        refetchInterval: 3600000, // 1 hour
        refetchOnWindowFocus: true, // Automatically refetch when tab becomes active
    });
}

export const useGetFrontendVersion = () => {
    return useQuery({
        queryKey: ['frontendVersion'],
        queryFn: async () => {
            try {
                const response = await fetch('/version.txt', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'text/plain',
                    },
                });

                if (response.ok) {
                    const versionText = await response.text();
                    const versionNumber = versionText.trim();
                    // TOTO
                    console.log('frontendVersion', versionNumber);
                    return '1';
                }
                return null;
            } catch (error) {
                console.error('Failed to fetch frontend version:', error);
                return null;
            }
        },
        staleTime: 300000, // 5 minutes
        retry: 2,
    });
}